import React from 'react';
import { ForgeBadge, ForgeButton, ForgeIcon } from '@tylertech/forge-react';
import { FilterParameterConfiguration } from 'common/types/reportFilters';
import { FilterBarPendoIds } from './types';
import I18n from 'common/i18n';

export interface ApplyAllFiltersButtonProps {
  filterParameterConfigurations?: FilterParameterConfiguration[];
  isReadOnly?: boolean;
  onApplyAll: (updated: FilterParameterConfiguration[]) => void;
  disabled?: boolean;
  pendoIds?: FilterBarPendoIds;
}

const scope = 'shared.components.filter_bar';

/**
 * Button component for applying all filters at once
 */
const ApplyAllFiltersButton: React.FC<ApplyAllFiltersButtonProps> = ({
  filterParameterConfigurations,
  onApplyAll,
  disabled = true,
  pendoIds
}) => {
  return (
    <div className="apply-filters-button-container" id={pendoIds?.applyAllFilters}>
      <ForgeBadge hide={disabled} theme="secondary" data-testid="new-filters-applied-badge">
        <ForgeIcon name="info" slot="start"></ForgeIcon>
        <span>{I18n.t('shared.components.filter_bar.new_filters_applied')}</span>
      </ForgeBadge>
      <ForgeButton
        variant="raised"
        onClick={() => {
          if (filterParameterConfigurations) {
            onApplyAll(filterParameterConfigurations);
          }
        }}
        data-testid="run-report-button"
        disabled={disabled}
      >
        {I18n.t('apply_all_filters', { scope })}
      </ForgeButton>
    </div>
  );
};

export default ApplyAllFiltersButton;
